<template>
  <div class="bg-block shadow-primaryBlock p-8 rounded mb-12">
    <div class="text-xl font-bold text-text leading-tight mb-4">
      <font-awesome-icon icon="exclamation-triangle" class="text-yellow text-xl mr-4"/>
      {{ $t('attention') }}
    </div>
    <div class="text-text text-sm">{{ $t('attentionText') }}</div>
  </div>
</template>

<script>
export default {
  name: "RecalculationAlert",
  i18n: {
    messages: {
      en: {
        attention: 'Attention!',
        attentionText: 'Information about the structure and statistics of your portfolio is now being updated. It is very nearly there!'
      },
      ru: {
        attention: 'Внимание!',
        attentionText: 'Информация о структуре и статистике вашего портфеля сейчас обновляется. Осталось совсем чуть-чуть!'
      }
    }
  }
}
</script>